import { PaletteMode } from "@mui/material";
import { blue, grey, indigo, red } from "@mui/material/colors";

export const getDesignTokens = (mode: PaletteMode) => ({
  typography: {
    button: {
      textTransform: "none",
    },
  },
  palette: {
    mode,
    ...(mode === "light"
      ? {
          // palette values for light mode
          main: "#001f3f",
          background: { paper: blue[100] },
          text: {
            primary: grey[900],
            secondary: grey[700],
          },
        }
      : {
          // palette values for dark mode
          main: grey[900],
          background: {
            default: grey[900],
            paper: grey[800],
          },
          text: {
            primary: "#fff",
            secondary: grey[200],
          },
        }),
  },
});
